module.exports = __webpack_public_path__ + "img/cctv@2x.5759d6db.png";